if(!customElements.get('button-to-top')) {
    class ButtonToTop extends HTMLElement {
        constructor() {
            super();

            this.onScroll = this.onScroll.bind(this);
            this.scrollToTop = this.scrollToTop.bind(this);

            this.style.display = 'block';
        }

        connectedCallback() {
            this.button = this.querySelector('.button-to-top');
            if (!this.button) return;

            this.button.style.display = 'none';

            this.button.addEventListener('click', this.scrollToTop.bind(this));

            this.onScroll();
            window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScroll);
            this.button?.removeEventListener('click', this.scrollToTop);
        }

        onScroll() {
            const threshold = window.innerHeight; // 100vh
            const shouldShow = window.scrollY > threshold;

            this.button.style.display = shouldShow ? '' : 'none';
        }


        scrollToTop(event) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }        
    }
    
    customElements.define('button-to-top', ButtonToTop);
}